export default __webpack_public_path__ + "static/media/download_2.2da480a7.svg";